import React, { useEffect, useRef, useState } from "react";
import Chip from "@mui/material/Chip";
import {
  Done as IconVerified,
  ThumbDownAlt as IconReject,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import TxtRow from "components/Custom/TxtRow";
import {
  API_CONFIG,
  CONFIG,
  CRM_LEAD_STATUS,
  DOC_UPLOAD_STATUS,
  NOTIFY,
} from "common/config";
import { COMMON_JS } from "common/scripts";
import { ERRORS, LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COLORS } from "common/colors";
import RadioBtn from "components/Custom/RadioBtn";
import SkeletonBox from "components/Custom/SkeletonBox";

import { CRM_APIs } from "apihandlers/crm";

import Comments from "../Comments";
import StatusButtons from "../StatusButtons";

interface defaultProps {}

const InterviewProcess = (props: any) => {
  const {
    selectedRow,
    onClose,
    isButtonDisabled,
    remarksList,
    getCrmRemarks,
    remarksLoading,
    setRemarksLoading,
    activeStep,
    nextStep,
  } = props;

  const interviewDetails = selectedRow.interviewDetails
    ? JSON.parse(selectedRow.interviewDetails)
    : {};
  const selectedRemarks = selectedRow.remarks
    ? JSON.parse(selectedRow.remarks)
    : {};

  const [loading, setLoading] = useState<boolean>(true);
  const [interviewProcess, setInterviewProcess] = useState(
    interviewDetails.interviewProcess || ""
  );
  let rescheduledDates = [];

  useEffect(() => {
    setInterval(() => {
      setLoading(false);
    }, 1000);
  }, [loading]);

  const manageRecord = async () => {
    try {
      const ele = document.getElementById("interviewTime") as HTMLInputElement;
      let interviewTime = "";
      if (ele) {
        interviewTime = ele.value;
      }
      const op = document.getElementById(
        "interviewRescheduleTime"
      ) as HTMLInputElement;
      let interviewRescheduleTime = "";
      if (op) {
        interviewRescheduleTime = op.value;
      }
      if (!interviewProcess) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_SELECT_INTERVIEW_PROCESS
        );
        return;
      }
      let crmLeadStatus = CRM_LEAD_STATUS.INTERVIEW_PROCESS;
      switch (interviewProcess) {
        case CRM_LEAD_STATUS.HOLD:
          break;
        case CRM_LEAD_STATUS.REJECT:
          break;
        default:
          break;
      }
      if (interviewProcess === "Interview Reschedule") {
        rescheduledDates.push(interviewRescheduleTime);
      }

      const remarks = (
        document.getElementById("remarks") as HTMLInputElement
      ).value.trim();
      const followupDate = (
        document.getElementById("followupDate") as HTMLInputElement
      ).value.trim();
      let argsRemarks = [];
      if (remarks) {
        argsRemarks = remarksList
          ? [...remarksList, { followupDate: followupDate, remarks: remarks }]
          : [{ followupDate: followupDate, remarks: remarks }];
      }

      let interviewDet = {
        interviewProcess,
        interviewTime,
      };
      if (interviewProcess == "Interview Reschedule") {
        interviewDet = { ...interviewDetails };
        interviewDet["interviewProcess"] = "Interview Reschedule";
        interviewDet["rescheduledDt"] = interviewDet["rescheduledDt"] || [];
        interviewDet["rescheduledDt"].push(interviewRescheduleTime);
      }
      const args = {
        interviewDetails: interviewDet,
        crmLeadId: selectedRow.id,
        crmLeadName: selectedRow.crmLeadName,
        activeStatus: selectedRow.activeStatus,
        crmLeadStatus,
        remarks: argsRemarks,
      };
      console.log("args: ", args);
      const res = await CRM_APIs.manageCrmLeadProfile(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
    } catch (error) {
      console.error("onConverted: ", error);
    }
  };

  let status = Object.values(CRM_LEAD_STATUS);
  let interviewProcessList = [
    {
      id: "Direct Approval",
      value: "Direct Approval",
      label: "Direct Approval ",
      checked: interviewProcess === "Direct Approval",
      disabled: false,
    },
    {
      id: "Interview Schedule",
      value: "Interview Schedule",
      label: "Interview Schedule ",
      checked: interviewProcess === "Interview Schedule",
      disabled: false,
    },
    {
      id: "Hold",
      value: "Hold",
      label: "Hold",
      checked: interviewProcess === "Hold",
      disabled: false,
    },
    {
      id: "Reject",
      value: "Reject",
      label: "Reject",
      checked: interviewProcess === "Reject",
      disabled: false,
    },
  ];
  if (
    interviewDetails.interviewProcess === "Interview Schedule" ||
    interviewDetails.interviewProcess === "Interview Reschedule"
  ) {
    interviewProcessList.push({
      id: "Interview Reschedule",
      value: "Interview Reschedule",
      label: "Interview Reschedule",
      checked: interviewProcess === "Interview Reschedule",
      disabled: false,
    });
  }
  console.log("selected row", selectedRow, status);

  return loading ? (
    <div>
      <SkeletonBox
        height={200}
        width={"100%"}
        style={{ borderRadius: 5, marginBottom: 15 }}
      />
      <SkeletonBox
        height={40}
        width={"20%"}
        style={{ borderRadius: 5, marginBottom: 25, marginTop: 35 }}
      />
      <SkeletonBox
        height={100}
        width={"50%"}
        style={{ borderRadius: 5, marginBottom: 25 }}
      />
      <div
        className="flexRow"
        style={{
          width: "50%",
          paddingRight: "2rem",
          justifyContent: "flex-end",
          alignItems: "right",
          marginBottom: "2rem",
        }}
      >
        <SkeletonBox
          height={35}
          width={"20%"}
          style={{ borderRadius: 5, marginBottom: 15 }}
        />
      </div>
      <div
        className="flexColumn"
        style={{
          alignItems: "flex-end",
          marginTop: "2rem",
          marginLeft: "2rem",
        }}
      >
        <div
          className="flexRow"
          style={{
            width: "30%",
            paddingRight: "2rem",
            justifyContent: "right",
            marginBottom: "2rem",
          }}
        >
          <SkeletonBox
            height={35}
            width={"50%"}
            style={{ borderRadius: 5, marginBottom: 15 }}
          />
        </div>
      </div>
    </div>
  ) : (
    <React.Fragment>
      <div
        className="formWrapper"
        style={{
          height: window.innerHeight * 0.68,
          overflow: "auto",
          paddingRight: "1rem",
        }}
      >
        <fieldset className="formSection">
          <legend className="formSectionLegend">
            {LABELS.INTERVIEW_PROCESS}
          </legend>
          <div
            style={{
              marginTop: -15,
              marginLeft: 20,
            }}
          >
            <RadioBtn
              name="interviewProcess"
              list={interviewProcessList}
              onChange={(val) => setInterviewProcess(val)}
            />
            {interviewProcess === "Interview Schedule" && (
              <div className="width30" style={{ marginBottom: 10 }}>
                <TxtBox
                  type={"datetime-local"}
                  id={"interviewTime"}
                  defaultValue={interviewDetails.interviewTime}
                />
              </div>
            )}
            {interviewProcess === "Interview Reschedule" && (
              <div className="width30" style={{ marginBottom: 10 }}>
                <TxtBox
                  type={"datetime-local"}
                  id={"interviewRescheduleTime"}
                  defaultValue={
                    interviewDetails.rescheduledDt &&
                    interviewDetails.rescheduledDt[
                      interviewDetails.rescheduledDt.length - 1
                    ]
                  }
                />
              </div>
            )}
          </div>
        </fieldset>

        {/* <div className="formGroup width60">
        <TxtRow
          id={"remarks"}
          type={"text"}
          label={LABELS.REMARKS}
          defaultValue={selectedRemarks.interviewRemarks || " "}
          //disabled={isSubmit}
          rows={4}
        />
        
      </div> */}
        <Comments
          selectedRow={selectedRow}
          isButtonDisabled={isButtonDisabled}
          remarksList={remarksList}
          getCrmRemarks={getCrmRemarks}
          remarksLoading={remarksLoading}
          setRemarksLoading={setRemarksLoading}
        />
        {/* <StatusButtons
          isButtonDisabled={isButtonDisabled}
          selectedRow={selectedRow}
          onClose={onClose}
          page={CRM_LEAD_STATUS.INTERVIEW_PROCESS}
        /> */}
      </div>

      <div
        className="flexColumn"
        style={{
          alignItems: "flex-end",
          marginTop: "2rem",
          marginLeft: "2rem",
        }}
      >
        <div
          className="flexRow"
          style={{
            width: "30%",
            paddingRight: "2rem",
            justifyContent: "right",
            marginBottom: "2rem",
          }}
        >
          <Btn
            text={LABELS.SAVE}
            onClick={manageRecord}
            style={{ width: "50%" }}
            bgColor={COLORS.SAVE_GREEN}
            // disabled={isButtonDisabled}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(InterviewProcess);
